import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberCyberriskcover = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "currentColor",
	viewBox: "0 0 64 64",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M31.531.39a1 1 0 0 1 .717.303 32.67 32.67 0 0 0 23.763 9.897 1 1 0 0 1 1.008.942l-.998.058.998-.057v.008l.002.023.004.085.013.323c.01.281.02.692.023 1.218a69 69 0 0 1-.123 4.42c-.219 3.714-.79 8.817-2.207 14.378-2.828 11.105-9.064 24.171-22.727 31.503a1 1 0 0 1-.946 0c-13.663-7.327-19.899-20.393-22.727-31.5-1.417-5.561-1.988-10.665-2.207-14.379-.109-1.857-.13-3.37-.123-4.422a45 45 0 0 1 .04-1.626l.001-.023v-.008l.999.057-.998-.058a1 1 0 0 1 1.009-.942A32.63 32.63 0 0 0 30.814.693 1 1 0 0 1 31.53.39M8.009 12.587q-.006.271-.008.616a67 67 0 0 0 .12 4.292c.213 3.622.77 8.595 2.148 14.003C12.994 42.2 18.89 54.471 31.53 61.471c12.64-7.005 18.537-19.276 21.262-29.977 1.377-5.407 1.935-10.38 2.148-14a67 67 0 0 0 .112-4.908 34.67 34.67 0 0 1-23.522-9.782 34.63 34.63 0 0 1-23.522 9.783",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M27.441 23.46a2.1 2.1 0 0 0-2.1 2.1v10.25c0 1.16.94 2.1 2.1 2.1h8.19a2.1 2.1 0 0 0 2.1-2.1V25.56a2.1 2.1 0 0 0-2.1-2.1zm-4.1 2.1a4.1 4.1 0 0 1 4.1-4.1h8.19a4.1 4.1 0 0 1 4.1 4.1v10.25a4.1 4.1 0 0 1-4.1 4.1h-8.19a4.1 4.1 0 0 1-4.1-4.1zM48.021 28.92a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-3.2 1.2a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M38.841 30.12a1 1 0 0 1 1-1h5.66a1 1 0 1 1 0 2h-5.66a1 1 0 0 1-1-1M43.301 16.19a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-3.2 1.2a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0M31.531 12.05a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-3.2 1.2a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0M31.531 47.72a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-3.2 1.2a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M43.301 18.59a1 1 0 0 1 1 1v5.07a1 1 0 0 1-1 1h-4.49a1 1 0 1 1 0-2h3.49v-4.07a1 1 0 0 1 1-1M43.821 41.64a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-3.2 1.2a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M38.331 35.58a1 1 0 0 1 1-1h4.49a1 1 0 0 1 1 1v5.06a1 1 0 1 1-2 0v-4.06h-3.49a1 1 0 0 1-1-1M15.051 28.92a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-3.2 1.2a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M16.561 30.12a1 1 0 0 1 1-1h5.66a1 1 0 1 1 0 2h-5.66a1 1 0 0 1-1-1M19.761 16.19a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-3.2 1.2a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M19.761 18.59a1 1 0 0 1 1 1v4.07h3.49a1 1 0 1 1 0 2h-4.49a1 1 0 0 1-1-1v-5.07a1 1 0 0 1 1-1M19.251 41.64a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-3.2 1.2a3.2 3.2 0 1 1 6.4 0 3.2 3.2 0 0 1-6.4 0",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M18.251 35.58a1 1 0 0 1 1-1h4.49a1 1 0 1 1 0 2h-3.49v4.06a1 1 0 1 1-2 0zM31.531 15.49a1 1 0 0 1 1 1v5.63a1 1 0 1 1-2 0v-5.63a1 1 0 0 1 1-1M31.531 37.91a1 1 0 0 1 1 1v7.27a1 1 0 1 1-2 0v-7.27a1 1 0 0 1 1-1",
			clipRule: "evenodd"
		})
	]
});
export default SvgCyberCyberriskcover;
